import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Home from './pages/Home';
import Circuits from './pages/Circuits';
import Cost from './pages/Cost';
import DataQuality from './pages/DataQuality';
import AuthCallback from './auth/AuthCallback';

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <AuthCallback /> },
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'circuits', element: <Circuits /> },
      { path: 'cost', element: <Cost /> },
      { path: 'data-quality', element: <DataQuality /> },
    ],
  },
]);
